<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Ricerca Progetto">
                <button type="button" class="btn btn-outline-primary mt-3" [routerLink]="['../crea']">
                    <app-toolkit-bl-icon icon="plus" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    <span class="d-none d-md-inline-block">Inserisci progetto</span>
                </button>
            </app-toolkit-page-title>
            <div class="card">
                <div class="card-body">
                    <form class="form" role="form" [formGroup]="criteriaForm" (ngSubmit)="submitForm(true)">
                        <div class="form-row pt-2">
                            <h6 class="col-12">Ricerca Progetto</h6>
                            <div class="form-group col-md-3">
                                <label for="idProgetto">ID progetto</label>
                                <input class="form-control" id="idProgetto" formControlName="idProgetto" type="number">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="sigla">Sigla</label>
                                <input class="form-control" id="sigla" formControlName="sigla" type="text">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="denominazione">Titolo progetto</label>
                                <input class="form-control" id="denominazione" formControlName="denominazione" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="descrizione">Descrizione</label>
                                <input class="form-control" id="descrizione" formControlName="descrizione" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="cup">CUP</label>
                                <input class="form-control" id="cup" formControlName="cup" type="text">
                            </div>
                            <!-- <div class="form-group col-md-3">
                                <label for="codiceUnivoco">Codice univoco</label>
                                <input class="form-control" id="codiceUnivoco" formControlName="codiceUnivoco" type="text">
                            </div> -->
                        </div>
                        <div class="button-actions">
                            <button type="button" class="btn btn-outline-primary" (click)="resetForm()">Pulisci</button>
                            <button type="submit" class="btn btn-primary">Ricerca</button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="card mt-4">
                <div class="card-body">
                    <h6 id="table_description">Risultati ricerca</h6>
                    <div style="transform: rotateX(180deg);" class="table-responsive mb-3">
                        <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_description">
                            <thead class="thead-light">
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Sigla</th>
                                    <th scope="col">Titolo progetto</th>
                                    <th scope="col">Descrizione</th>
                                    <th scope="col">CUP</th>
                                    <!-- <th scope="col">Codice univoco</th> -->
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of tableData">
                                    <td>{{ item.idProgetto }}</td>
                                    <td>{{ item.sigla }}</td>
                                    <td>{{ item.denominazione }}</td>
                                    <td>{{ item.descrizione | slice:0:100 }}</td>
                                    <td>{{ item.cup }}</td>
                                    <!-- <td>{{ item.codiceUnivoco }}</td> -->
                                    <td class="actions">
                                        <button aria-label="accedi al dettaglio" type="button" (click)="goToProgetto(item.idProgetto)" class="btn btn-xs btn-link" container="body" ngbTooltip="Accedi al dettaglio">
                                            <app-toolkit-bl-icon icon="arrow-right" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="!tableData.length">
                                    <td colspan="8"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ngb-pagination
                        *ngIf="tableData.length"
                        [(page)]="paginator.page"
                        [pageSize]="paginator.size"
                        [collectionSize]="paginator.total"
                        (pageChange)="onPageChange($event)"
                        [maxSize]="5"
                        ></ngb-pagination>
                </div>
            </div>
        </div>
    </div>
</div>